import { Grid, styled } from "@mui/material";

const Header = styled(Grid)(({ theme }) => ({
  color: theme.palette.info.main,
  fontSize: "12px",
  fontWeight: 600,
  fontFamily: "Poppins",
  color: "#757E97",
}));

const ProgramTitles = () => {
  return (
    <Grid
      container
      sx={{
        display: { xs: "none", sm: "flex" },
        justifyContent: "space-between",
        padding: "6px 16px",
      }}
    >
      <Header
        item
        xs={3}
        sx={{ display: "flex", gap: "10px", alignItems: "center" }}
      >
        Titre
      </Header>
      <Header item md={2}>
        Client
      </Header>
      <Header item md={3}>
        Dates
      </Header>
      <Header item md={1}>
        Progression
      </Header>
      <Header item md={2} pl={3}>
        Statut
      </Header>
      <Header item md={1} sx={{ textAlign: "right" }}>
        Actions
      </Header>
    </Grid>
  );
};

export default ProgramTitles;
